<template>
  <!-- <n-form-item label="Store Manager Name" path="Branch">

    </n-form-item> -->

  <!-- <n-input v-model="branchname" placeholder="Enter Store Manager Name" /> -->

  <!-- <n-select   :options="options" /> -->
  <!-- <Dropdown :options="branch_data" /> -->
  <CustomDropDown v-model="model" :disabled="disabled" :items="branch_data" :name="name" :label="$t('5000.Branch')"
    :rules="{ required: true }" :required-icon="true" id="branch" @update:modelValue="input" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import { useRoute } from 'vue-router';

import commonservice from "../../modules/Inventory/Service/StoreService";
import CustomDropDown from "../FormComponents/Dropdown.vue";
import LoginService from "../../Services/LoginService";

export default defineComponent({
  props: {
    branchname: {
      type: String,
      default: ref(""),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    textField: {
      type: String,
      default: "name",
    },
    items: {
      type: [],
      default: () => {
        return [];
      },
    },
    valueField: {
      type: String,
      default: "value",
    },
    vid: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    invalid: {
      type: String,
      default: "This field is required",
    },
    value: {},
    modelValue: {
      type: String,
      default: null,
    },
    // textField: {
    //     type: String,
    //     default: "name",
    // },
    // Designation: {
    //     type: String,
    //     default: ''
    // }
  },
  components: {
    CustomDropDown,
  },
  setup(props, { emit }) {
    const model = ref();
    const branch_data = ref([]);
    let session: any = localStorage.getItem("UsersData");
    const router = useRoute();
    session = JSON.parse(session);
    let HospitalId = session.OrganizationId;
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    watch(props, (newValue) => {
      debugger;
      model.value = newValue.modelValue;
      input();
    });
    // watch(
    //     () => props.modelValue,
    //     (newVal) => {
    //         debugger;
    //         model.value = newVal
    //         input()
    //     }
    // );
    onMounted(() => {
      debugger;
      model.value = props.modelValue;
      input();
    });

    function input() {
      debugger;
      emit("update:modelValue", model.value);
    }
    //Branch Load
    async function LoadBranch() {
      debugger;
      // const dataModel = {
      const data_response = await LoginService.GetBranchesByUserId(
        usersData.UserId
      );

      branch_data.value = data_response["result"].map(
        (item) => {
          item.name = item.BranchName;
          item.value = item.BranchId;
          return item;
        }
      );
    }

    return {
      model,
      LoadBranch,
      branch_data,
      input,
      branch_value: ref(null),
    };
  },
  async created() {
    await this.LoadBranch();
  },
});
</script>

<style lang="scss" scoped></style>
